import React from 'react';
import { useHistory } from 'react-router-dom';
import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { QueryClientProvider } from '../contexts/QueryClientProvider';
import AdminLayout from './Components/AdminLayout.js';
import useDocumentTitle from '../utils/useDocumentTitle.js';
import { oktaAuthConfig } from './Configurations/OktaConfig.js';
import { AdminAuthProvider } from './Contexts/AdminAuthContext.js';

const oktaAuth = new OktaAuth({
    ...oktaAuthConfig,
    redirectUri: `${window.location.origin}/`,
});

const AdminApp = (props) => {
    useDocumentTitle('LTOE Timesheet and Expense');
    const history = useHistory();
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        const uri = '/login/callback';
        history.replace(toRelativeUrl(uri, window.location.origin));
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <AdminAuthProvider>
                <QueryClientProvider>
                    <AdminLayout />
                </QueryClientProvider>
            </AdminAuthProvider>
        </Security>
    );
};

export default AdminApp;
